import { gameIdSchema, handoffIdSchema, upgradeIdSchema } from '@argus-labs/auth-shared/auth'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { z } from 'zod'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const commonSearchSchema = z.object({
  handoffId: handoffIdSchema.optional(),
  // Identifies the separate guest-upgrade flow through signup and email verification.
  upgradeId: upgradeIdSchema.optional(),
  // The organization/project identifier shown during handoffs and guest upgrades.
  gameId: gameIdSchema.optional(),
})

// Better Auth error codes for email OTP plugin specifically
// Unfortunately they aren't exported so we need to duplicate them here
// https://github.com/better-auth/better-auth/blob/6b29a9ca414bd2f70c391075cfa66baaba739341/packages/better-auth/src/plugins/email-otp/index.ts#L106-L112
export const BETTER_AUTH_EMAIL_OTP_ERROR_CODES = {
  OTP_EXPIRED: 'OTP_EXPIRED',
  INVALID_OTP: 'INVALID_OTP',
  INVALID_EMAIL: 'INVALID_EMAIL',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  TOO_MANY_ATTEMPTS: 'TOO_MANY_ATTEMPTS',
} as const

// Better Auth error interface (not exported, hence the need to duplicate it here)
export interface BetterAuthAPIError {
  code?: string | undefined
  message?: string | undefined
  status: number
  statusText: string
}

export function generateTitle(title: string) {
  return `${title} - Argus Auth`
}
